import { OrganisationPermissionConstants, ProjectPermissionConstants } from "../../../constants";
import { VerifierSingleCardWithTabsTemplate } from "../../../templates";
import { useAuth } from "../../../useAuth";

const Settings = (): JSX.Element => {
  const { hasPermission } = useAuth();

  let tabsList = [
    { route: "/v/settings/organisation", label: "Organisation" },
    {
      route: "/v/settings/marketing-assets",
      label: "Marketing assets",
    },
  ];

  if (hasPermission(OrganisationPermissionConstants.READ_ORGANISATION_USERS))
    tabsList = [
      {
        route: "/v/settings/users",
        label: "Users",
      },
      ...tabsList,
    ];

  if (
    hasPermission(ProjectPermissionConstants.READ_ALL_PROJECT_AUDIT) ||
    hasPermission(ProjectPermissionConstants.READ_OWN_ORG_PROJECT_AUDIT)
  )
    tabsList = [
      ...tabsList,
      {
        route: "/v/settings/audit-history",
        label: "Audit history",
      },
    ];

  return (
    <div>
      <VerifierSingleCardWithTabsTemplate activeElement="Settings" pageTitle="Settings" tabsList={tabsList} />
    </div>
  );
};

export default Settings;
